function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 4H11C10.4477 4 10 3.55228 10 3C10 2.44772 10.4477 2 11 2H21C21.5523 2 22 2.44772 22 3C22 3.55228 21.5523 4 21 4Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 30H1.99998C1.46791 30.0054 0.956057 29.7964 0.579807 29.4202C0.203556 29.0439 -0.00542203 28.5321 -1.98798e-05 28V4C-0.00542203 3.46793 0.203556 2.95608 0.579807 2.57983C0.956057 2.20358 1.46791 1.9946 1.99998 2H6.99998C7.55226 2 7.99998 2.44772 7.99998 3C7.99998 3.55229 7.55226 4 6.99998 4H1.99998V28H30V4H25C24.4477 4 24 3.55229 24 3C24 2.44772 24.4477 2 25 2H30C30.5321 1.9946 31.0439 2.20358 31.4202 2.57983C31.7964 2.95608 32.0054 3.46793 32 4V28C32.0054 28.5321 31.7964 29.0439 31.4202 29.4202C31.0439 29.7964 30.5321 30.0054 30 30Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31 10H1C0.447715 10 0 9.55228 0 9C0 8.44772 0.447715 8 1 8H31C31.5523 8 32 8.44772 32 9C32 9.55228 31.5523 10 31 10Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 6H11C11.5523 6 12 5.55228 12 5V1C12 0.447715 11.5523 0 11 0H7C6.44772 0 6 0.447715 6 1V5C6 5.55228 6.44772 6 7 6ZM10 4H8V2H10V4Z",
  fill: "#32D882"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 6H25C25.5523 6 26 5.55228 26 5V1C26 0.447715 25.5523 0 25 0H21C20.4477 0 20 0.447715 20 1V5C20 5.55228 20.4477 6 21 6ZM24 4H22V2H24V4Z",
  fill: "#32D882"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13 24H9C8.44772 24 8 23.5523 8 23V20C8 18.8954 8.89543 18 10 18H12V16H9C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14H12C13.1046 14 14 14.8954 14 16V18C14 19.1046 13.1046 20 12 20H10V22H13C13.5523 22 14 22.4477 14 23C14 23.5523 13.5523 24 13 24Z",
  fill: "#32D882"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21 24H19C18.4477 24 18 23.5523 18 23C18 22.4477 18.4477 22 19 22H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H19C18.4477 20 18 19.5523 18 19V15C18 14.4477 18.4477 14 19 14H23C23.5523 14 24 14.4477 24 15C24 15.5523 23.5523 16 23 16H20V18H21C22.6569 18 24 19.3431 24 21C24 22.6569 22.6569 24 21 24Z",
  fill: "#32D882"
});

var SvgVenueManagment2 = function SvgVenueManagment2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment2.55db110c.svg";
export { ForwardRef as ReactComponent };